function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import styles from './FixedLeftNav.module.scss';

var SecondaryNavInternal = function SecondaryNavInternal(_ref) {
    var href = _ref.href,
        Icon = _ref.Icon,
        title = _ref.title,
        Component = _ref.Component,
        label = _ref.label;
    return React.createElement(
        Component,
        { to: href, className: styles['secondary-link'], activeClassName: styles['secondary-link-selected'] },
        Icon && React.createElement(Icon, null),
        React.createElement(
            'span',
            null,
            title
        ),
        label && React.createElement(Label, { text: label })
    );
};

var SecondaryExternalNav = function SecondaryExternalNav(_ref2) {
    var linkKey = _ref2.linkKey,
        Icon = _ref2.Icon,
        title = _ref2.title,
        Component = _ref2.Component,
        NavIcon = _ref2.NavIcon,
        label = _ref2.label;
    return React.createElement(
        Component,
        { className: styles['secondary-link'], linkKey: linkKey, newTab: true },
        Icon && React.createElement(Icon, null),
        React.createElement(
            'span',
            null,
            title
        ),
        React.createElement(NavIcon, { className: styles['secondary-external-icon'] }),
        label && React.createElement(Label, { text: label })
    );
};

var NavDropDown = function NavDropDown(_ref3) {
    var Icon = _ref3.Icon,
        title = _ref3.title,
        onMouseOver = _ref3.onMouseOver,
        NavIcon = _ref3.NavIcon;
    return React.createElement(
        'button',
        { className: styles['link'], onMouseOver: onMouseOver },
        React.createElement(Icon, null),
        React.createElement(
            'span',
            null,
            title
        ),
        React.createElement(NavIcon, { className: styles['drop-down-icon'] })
    );
};

var NavExternal = function NavExternal(_ref4) {
    var linkKey = _ref4.linkKey,
        Icon = _ref4.Icon,
        title = _ref4.title,
        Component = _ref4.Component,
        NavIcon = _ref4.NavIcon,
        label = _ref4.label;
    return React.createElement(
        Component,
        { className: styles['link'], linkKey: linkKey, newTab: true },
        React.createElement(Icon, null),
        React.createElement(
            'span',
            null,
            title
        ),
        React.createElement(NavIcon, { className: styles['external-icon'] }),
        label && React.createElement(Label, { text: label })
    );
};

var NavInternal = function NavInternal(_ref5) {
    var to = _ref5.to,
        Icon = _ref5.Icon,
        title = _ref5.title,
        Component = _ref5.Component,
        label = _ref5.label;
    return React.createElement(
        Component,
        { to: to, className: styles['link'], activeClassName: styles['link-selected'] },
        React.createElement(Icon, null),
        React.createElement(
            'span',
            null,
            title
        ),
        label && React.createElement(Label, { text: label })
    );
};

var NavAction = function NavAction(_ref6) {
    var Icon = _ref6.Icon,
        title = _ref6.title,
        onClick = _ref6.onClick,
        label = _ref6.label;
    return React.createElement(
        'button',
        { className: '' + styles['link'], onClick: onClick },
        React.createElement(Icon, null),
        React.createElement(
            'span',
            null,
            title
        ),
        label && React.createElement(Label, { text: label })
    );
};

var Label = function Label(_ref7) {
    var text = _ref7.text;
    return React.createElement(
        'div',
        { className: styles['label'] },
        text
    );
};

var _default = function (_Component) {
    _inherits(_default, _Component);

    function _default(props) {
        _classCallCheck(this, _default);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {};
        return _this;
    }

    _default.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            mainLinks = _props.mainLinks,
            InternalLink = _props.InternalLink,
            ExternalLink = _props.ExternalLink,
            HeaderButton = _props.HeaderButton,
            ArrowIcon = _props.ArrowIcon,
            ExternalLinkIcon = _props.ExternalLinkIcon;

        return React.createElement(
            'div',
            { onMouseLeave: function onMouseLeave() {
                    _this2.setState({ openDropDown: null });
                } },
            React.createElement(
                'nav',
                { className: styles['base'] },
                React.createElement(
                    'div',
                    { className: styles['header'] },
                    React.createElement(HeaderButton, null)
                ),
                React.createElement(
                    'div',
                    { className: styles['links'] },
                    mainLinks.map(function (_ref8) {
                        var isExternalLink = _ref8.isExternalLink,
                            isDropdown = _ref8.isDropdown,
                            isAction = _ref8.isAction,
                            href = _ref8.href,
                            linkKey = _ref8.linkKey,
                            Icon = _ref8.Icon,
                            title = _ref8.title,
                            onClick = _ref8.onClick,
                            links = _ref8.links,
                            label = _ref8.label;


                        return React.createElement(
                            'div',
                            { key: title, onMouseOver: function onMouseOver(el) {
                                    _this2.setState({ openDropDown: null });
                                } },
                            isDropdown && React.createElement(NavDropDown, { NavIcon: ArrowIcon, Icon: Icon, title: title, links: links, key: title, onMouseOver: function onMouseOver(el) {
                                    el.stopPropagation();
                                    if (_this2.state.openDropDown !== links) {
                                        _this2.setState({ openDropDown: links, dropDownTop: el.currentTarget.getBoundingClientRect().top });
                                    }
                                } }),
                            isAction && React.createElement(NavAction, { label: label, Icon: Icon, title: title, onClick: onClick, key: title, onMouseOver: function onMouseOver(el) {
                                    _this2.setState({ openDropDown: null });
                                } }),
                            isExternalLink && React.createElement(NavExternal, { label: label, NavIcon: ExternalLinkIcon, Component: ExternalLink, linkKey: linkKey, Icon: Icon, title: title, key: title, onMouseOver: function onMouseOver(el) {
                                    _this2.setState({ openDropDown: null });
                                } }),
                            !isDropdown && !isAction && !isExternalLink && React.createElement(NavInternal, { label: label, Component: InternalLink, to: href, Icon: Icon, title: title, key: title, onMouseOver: function onMouseOver(el) {
                                    _this2.setState({ openDropDown: null });
                                } })
                        );
                    })
                )
            ),
            this.state.openDropDown && React.createElement(
                'nav',
                { className: styles['secondary-nav'], style: { top: this.state.dropDownTop, maxHeight: 'calc(100% - ' + this.state.dropDownTop + 'px)' } },
                this.state.openDropDown.map(function (_ref9) {
                    var isExternalLink = _ref9.isExternalLink,
                        Icon = _ref9.Icon,
                        title = _ref9.title,
                        href = _ref9.href,
                        linkKey = _ref9.linkKey,
                        label = _ref9.label;

                    if (isExternalLink) {
                        return React.createElement(SecondaryExternalNav, { label: label, NavIcon: ExternalLinkIcon, Component: ExternalLink, Icon: Icon, title: title, linkKey: linkKey, key: title });
                    } else {
                        return React.createElement(SecondaryNavInternal, { label: label, Component: InternalLink, Icon: Icon, title: title, href: href, key: title });
                    }
                })
            )
        );
    };

    return _default;
}(Component);

export { _default as default };